// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-centered[data-v-05a51872] {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; /* Center horizontally */\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; /* Center vertically */\n  height: 100vh; /* Full height of the viewport */\n}\n", ""]);
// Exports
module.exports = exports;
